export const device = {
  isMobile: window.innerWidth <= 600,
  isTablet: window.innerWidth >= 601 && window.innerWidth <= 1200,
  isDesktop: window.innerWidth >= 1201 && window.innerWidth <= 1025,
}
